import { render, staticRenderFns } from "./OrganizationEditor.vue?vue&type=template&id=d681197e&scoped=true"
import script from "./OrganizationEditor.vue?vue&type=script&lang=js"
export * from "./OrganizationEditor.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEditor.vue?vue&type=style&index=0&id=d681197e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d681197e",
  null
  
)

export default component.exports